// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangePassword_container__TIlz_","title":"ChangePassword_title__3wQTh","form":"ChangePassword_form__1mWdR","buttonContainer":"ChangePassword_buttonContainer__3tTfk"};